import { useMemo } from 'react'
import { useLocation } from 'react-router'

import { COMMON_ICONS_TYPE, commonIcons } from '@apps-common/config/icons'
import { Route, RouteGroup } from '@apps-common/types/routes'
import { PRIVATE_ROUTES } from '@apps-radionet-portal/config/private-routes'

interface IProps {
  label: string
  icon?: COMMON_ICONS_TYPE
}

export const BreadcrumbItem: React.FC<IProps> = ({ label, icon }) => {
  const location = useLocation()
  const ArrowIcon = commonIcons.breadcrumbArrowForward
  const routes = useMemo(() => PRIVATE_ROUTES.reduce((acc: Route[], curr: RouteGroup) => [...acc, ...curr.routes], []), [])
  const route = routes.find((r) => location?.pathname?.startsWith(r.path))

  const Icon: any = icon ? commonIcons[icon] : null

  return (
    <div className='flex items-center justify-start gap-[3.5px]'>
      <ArrowIcon className='text-[0.85em]' />
      <span className='text-[0.75em] jost-light flex items-center justify-start gap-[3.5px]'>
        {label}
        {/* {Icon && <Icon className='text-[1em]' color='fill-primary-content' classes='w-[16px]' />} */}
      </span>
    </div>
  )
}
